import { useEffect, useState } from "react";
import { getCurrentWeather } from "../data/dashboardData";
import { FaCloud, FaCloudRain, FaCloudShowersHeavy, FaCloudSun, FaSun, FaSnowflake, FaExclamationTriangle, FaCloudMoon, FaCloudMoonRain, FaMoon, FaCaretDown, FaCaretUp } from "react-icons/fa";

type WeatherDataType = {
  current: {
    temperature: number;
    cloudCover: number;
    rain?: number;
    showers?: number;
    isDay: number;
  }
  daily: [{
    maxTemp: number;
    minTemp: number;
  }]
};

const WeatherWidget = () => {
   const [weather, setWeather] = useState<WeatherDataType | null>(null);
   const [weatherIcon, setWeatherIcon] = useState<JSX.Element | null>(null);
   const [weatherDescription, setWeatherDescription] = useState<string | null>(null);
   const [belowZero, setBelowZero] = useState<boolean>(false);
   const [isDay, setIsDay] = useState<number>(1);

   useEffect(() => {
      const fetchWeatherData = async () => {
         await getCurrentWeather().then((data: any) => {
            setWeather(data);
         });
      };

      fetchWeatherData();
   }, []);

   useEffect(() => {
      if (!weather) return;
      
      const showers = weather.current.showers ?? 0;
      const rain = weather.current.rain ?? 0;
      const cloudCover = weather.current.cloudCover;

      if(weather.current.temperature < 0) setBelowZero(true);

      if (weather.current.isDay === 0) setIsDay(0);

      if(isDay === 1){
         if (showers > 0) {
            setWeatherIcon(<FaCloudShowersHeavy />);
            setWeatherDescription("Showers");
         } else if (rain > 0) {
            setWeatherIcon(<FaCloudRain />);
            setWeatherDescription("Raining");
         } else if (cloudCover > 70) {
            setWeatherIcon(<FaCloud />);
            setWeatherDescription("Mostly Cloudy");
         } else if (cloudCover > 10) {
            setWeatherIcon(<FaCloudSun />);
            setWeatherDescription("Partially Cloudy");
         } else {
            setWeatherIcon(<FaSun />);
            setWeatherDescription("Clear Skies");
         }
      } else {
         if (showers > 0) {
            setWeatherIcon(<FaCloudMoonRain />);
            setWeatherDescription("Showers");
         } else if (rain > 0) {
            setWeatherIcon(<FaCloudMoonRain />);
            setWeatherDescription("Raining");
         } else if (cloudCover > 70) {
            setWeatherIcon(<FaCloud />);
            setWeatherDescription("Mostly Cloudy");
         } else if (cloudCover > 10) {
            setWeatherIcon(<FaCloudMoon />);
            setWeatherDescription("Partially Cloudy");
         } else {
            setWeatherIcon(<FaMoon />);
            setWeatherDescription("Clear Skies");
         }
      }


   }, [weather]);

   return (
      <div style={{ display: "flex", flexDirection: "row", justifyContent: "center", position: "relative" }}>
         <div style={{ fontSize: "26pt", marginRight: "0.5em", display: "flex", justifyContent: "center", alignItems: "center" }}>{weatherIcon}</div>
         {
            belowZero ? 
            <div style={{ display: "flex", flexDirection: "row" }}>
               <div style={{ fontSize: "26pt", position: "relative", left: "-15px" }}>
                  <FaSnowflake style={{ color: "#8ff6ff" }} />
               </div>
               <div style={{ fontSize: "26pt", position: "relative", left: "-25px", top: "-10px" }}>
                  <FaExclamationTriangle style={{ color: "yellow", fontSize: "14pt" }} />
               </div>
            </div>
            :
            <></>
         }
         <div style={{ display: "flex", flexDirection: "column", marginRight: "2em", justifyContent: "center" }}>
            <div style={{fontSize: "20pt", fontWeight: "600"}}>
               {weather ? weather.current.temperature : "Loading..."}&deg;
            </div>
            <div style={{fontSize: "10pt", fontWeight: "300", margin: 0, lineHeight: "8pt"}}>
               {weatherDescription}
            </div>
         </div>
         {
            weather?.daily?.map((dayData: any, index: number) => (
               <div style={{ display: "flex", flexDirection: "column", marginRight: "2em" }} key={index}> 
                  <p style={{ margin: 0 }}>{dayData.time}</p>
                  <p style={{ margin: 0, fontSize: "12pt", fontWeight: "600" }}><FaCaretUp style={{ color: "orange" }} /> {dayData.maxTemp}</p>
                  <p style={{ margin: 0, fontSize: "12pt", fontWeight: "600" }}><FaCaretDown style={{ color: "cyan" }} /> {dayData.minTemp}</p>
               </div>
            ))
         }
      </div>
   );
}

export default WeatherWidget;